import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Widget } from "src/shared_components/interfaces";

export interface WidgetsState {
  widgets: Widget[];
  loading: boolean;
  error: string | null;
}

const initialState: WidgetsState = {
  widgets: [],
  loading: false,
  error: null,
};

const widgetsSlice = createSlice({
  name: "widgets",
  initialState,
  reducers: {
    fetchWidgetsStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchWidgetsSuccess: (state, action: PayloadAction<Widget[]>) => {
      state.loading = false;
      state.widgets = action.payload;
    },
    fetchWidgetsFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    addWidget: (state, action: PayloadAction<Widget>) => {
      state.widgets.push(action.payload);
    },
    reorderWidget: (state, action: PayloadAction<Widget[]>) => {
      const updatedWidgets = action.payload.map((widget, index) => ({
        ...widget,
        widgetPosition: index + 1,
      }));

      state.widgets = updatedWidgets;
    },
    updateWidget: (state, action: PayloadAction<Widget[]>) => {
      state.widgets = action.payload;
    },
    removeWidget: (state, action: PayloadAction<number>) => {
      state.widgets = state.widgets.filter(
        (item: Widget) => item.widgetId != action.payload
      );
    },
  },
});

export const {
  fetchWidgetsStart,
  fetchWidgetsSuccess,
  fetchWidgetsFailure,
  addWidget,
  reorderWidget,
  updateWidget,
  removeWidget,
} = widgetsSlice.actions;

export default widgetsSlice.reducer;
